import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import cx from 'classnames'

import Logo from 'components/ui/Logo/Logo'
import Box from 'components/_new/layout/Box/Box'

import BottomSection from './BottomSection/BottomSection'
import UpgradeSection from './UpgradeSection/UpgradeSection'
import HeroSection from '../components/HeroSection/HeroSection'
import TimerSection from '../components/TimerSection/TimerSection'
import ProductsSection from '../components/ProductsSection/ProductsSection'

import s from './ExceptMobile.scss'


const ExceptMobile = (props) => {
  const {
    messages, redirectLink, isUpgradable, isProductsSectionEnabled,
    hasLockedProductsAfterSubscription, email,
  } = props

  const { heroSection, timerSection, upgradeSection, bottomSection } = messages

  return (
    <Fragment>
      <div className={cx({ [s.backgroundGray]: isProductsSectionEnabled })}>
        <Box pt="48" alignCenter>
          <Logo dark />
        </Box>
        <HeroSection messages={heroSection} email={email} />
        {
          !hasLockedProductsAfterSubscription && (
            <TimerSection messages={timerSection} />
          )
        }
        {
          isProductsSectionEnabled && (
            <Box className={s.productsSection} center>
              <ProductsSection redirectLink={links.queue} />
            </Box>
          )
        }
      </div>
      <UpgradeSection messages={upgradeSection} isVisible={isUpgradable} redirectLink={redirectLink} />
      <BottomSection messages={bottomSection} redirectLink={redirectLink} />
    </Fragment>
  )
}

ExceptMobile.propTypes = {
  email: PropTypes.string,
  redirectLink: PropTypes.string,
  isUpgradable: PropTypes.bool,
  isProductsSectionEnabled: PropTypes.bool,
  hasLockedProductsAfterSubscription: PropTypes.bool,
}


export default ExceptMobile
